<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <div
        data-slot="item-title"
        :class="cn('flex w-full items-center gap-2 font-semibold text-base leading-4 self-stretch!', props.class)"
    >
        <slot />
    </div>
</template>
